import axios from 'axios';
import { auth } from '../shared/firebase/firebase-config';

const BASE_URL =
  window.location.hostname === 'localhost'
    ? 'http://localhost:8888'
    : window.location.origin;

const instance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

instance.interceptors.request.use(async (config) => {
  if (config.url?.includes('/api/auth/checkAuth')) {
    return config;
  }

  const idToken = await auth.currentUser?.getIdToken();
  if (idToken) {
    config.headers.Authorization = `Bearer ${idToken}`;
  }
  return config;
});

export default instance;
